export default __webpack_public_path__ + "static/media/marin5.714210c2.jpg";